import { Icons } from "assets";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import NotificationsDropDown from "shared/dropdowns/notifications";
import { setBreadCrumb } from "shared/redux/reducers/breadCrumbSlice";
import { GetNotificationsCountService } from "shared/services/notifications";
import { findScreenTitle } from "shared/utils/helper";
import BreadCrumb from "../breadCrumb";
import styles from "./style.module.scss";
import { GetQuestionsService } from "shared/services/questionnaire";
import { setQuestionsReducer } from "shared/redux/reducers/questions";
import { GetArchiveCountService } from "shared/services/evaluations";
import { setArchiveCountReducer } from "shared/redux/reducers/archiveCount";
import { routeConstant } from "shared/routes/routeConstant";
import Switch from "../switch";
import { setTheme } from "shared/redux/reducers/theme";

interface Props {
  openMobile: () => void;
  user: any;
}

function DashboardHeader({ openMobile, user }: Props) {
  const {
    theme: { theme },
  } = useSelector((state: any) => state?.root);
  const location = useLocation();
  const dispatch = useDispatch();

  const [showNotifications, setShowNotifications] = useState(false);
  const [count, setCount] = useState<number>(0);

  const handleGetCount = () => {
    GetArchiveCountService()
      .then(({ data }) => {
        dispatch(setArchiveCountReducer({ count: data }));
      })
      .catch((err) => {});
  };

  const handleGetQuestions = () => {
    GetQuestionsService()
      .then(({ data }) => {
        dispatch(setQuestionsReducer({ questions: data }));
      })
      .catch((err) => {})
      .finally(() => {});
  };

  const handleGetUnReadNotificationsCount = () => {
    GetNotificationsCountService()
      .then(({ data }) => {
        setCount(data?.count);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    handleGetCount();
    handleGetQuestions();
    handleGetUnReadNotificationsCount();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      location.pathname !==
        routeConstant.evaluationRecordDetail.path.replace(
          ":id",
          location.pathname.split("/")?.[3]
        ) &&
      location.pathname !==
        routeConstant.cgpEvaluationRecordDetail.path.replace(
          ":id",
          location.pathname.split("/")?.[3]
        ) &&
      location.pathname !==
        routeConstant.continueDraftEvaluation.path.replace(
          ":id",
          location.pathname.split("/")?.[3]
        )
    ) {
      dispatch(
        setBreadCrumb({
          crumbs: [
            {
              title: findScreenTitle(location.pathname),
            },
          ],
          prePath: location.pathname,
        })
      );
    }

    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <>
      <div className={classNames(styles.topLevelContainer)}>
        <div className={classNames("w-full", styles.headerContainer)}>
          <div className={classNames("flex items-center gap-3")}>
            <Icons.Hamburger
              className={classNames(styles.hamburgerIcon)}
              onClick={openMobile}
            />
            <BreadCrumb />
          </div>
          <div className={classNames("flex items-center relative gap-[12px]")}>
            <div className={classNames("flex items-center gap-[12px]")}>
              <label
                className={classNames(
                  styles.themeTitle,
                  theme === "light" ? styles.activeTheme : ""
                )}
              >
                Light
              </label>
              <Switch
                toggle={theme === "dark"}
                handleChange={() => {
                  if (theme === "dark") {
                    dispatch(setTheme({ theme: "light" }));
                  } else {
                    dispatch(setTheme({ theme: "dark" }));
                  }
                }}
              />
              <label
                className={classNames(
                  styles.themeTitle,
                  theme === "dark" ? styles.activeTheme : ""
                )}
              >
                Dark
              </label>
            </div>
            <div
              className={classNames(styles.notifyContainer)}
              onClick={() => {
                setShowNotifications(!showNotifications);
              }}
            >
              <Icons.Bell />
              {count ? <div className={classNames(styles.dot)} /> : null}
            </div>
            <NotificationsDropDown
              show={showNotifications}
              setShow={setShowNotifications}
              count={count}
              setCount={setCount}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardHeader;
